<template>
  <div id="page-product-bundle-details">

    <div class="mb-4">
      <h1>Product Bundle: {{ model.OrionBundleName }}</h1>
    </div>

    <product-bundle-form
        v-model="model"
        :loading="loading"
        ref="form"
        card-title="Edit Product Bundle"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'product-bundles.view', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductBundleForm from "@/views/pages/product-bundles/ProductBundleForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "ProductBundleEdit",
  components: {
    ProductBundleForm
  },
  mixins: [ ViewModelMixin, NotificationMixin, SaveModelMixin ],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.productBundles,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const multiReferences = [
        {
          array: 'main_raters',
          key: ['Product_FK', 'ORABundle_FK']
        },
      ];

      if (params.main_raters.length) {
        params.main_raters.forEach(main_raters => {
          if (main_raters.cross_selling.length) {
            this.setMultiReferences(
              [
                {
                  array: 'cross_selling',
                  key: ['Product_FK'],
                },
              ],
              main_raters
            );
          }
        });
      }

      this.setReferences(['ORABundle_FK'], params);
      this.setMultiReferences(multiReferences, params);

      return params;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      try {
        const { data } = await this.$api.productBundles.update(this.id, params);
        this.notifySuccess('Bundle updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Bundle failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
